import UDButton from 'ud-ui/components/button';
import sizes from 'modules/application-link/domain/constants/sizes';
import styled from '@emotion/styled';

const styles = {
  Button: styled(UDButton)`
    transition:
      background-color 0.2s ease-in-out,
      color 0.2s ease-in-out;

    &:disabled {
      background-color: #c0c0c0 !important;
      outline: #c0c0c0 !important;
      border: 1px solid #c0c0c0 !important;
      color: ${({ theme }) => theme.colors.DarkBlue} !important;

      cursor: not-allowed;
    }
  `,
  CheckboxContainer: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    @media (max-width: ${sizes.mobile.WIDTH}px) {
      justify-content: start;
    }
  `,
};

export default styles;
